import { FlowControlPlayoutSegmentRow } from './flow-control-playout-segment-row';
import type { VirtualInBetweenPlayout } from '@/helpers/flow-control-in-between-playout.helper';
import { useTranslations } from '@/i18n/use-translations';

type FlowControlVirtualInBetweenPlayoutRowProps = {
  virtual: VirtualInBetweenPlayout;
  isExpanded: boolean;
  onToggleExpand: () => void;
};

/** Control tab: dynamic transition/resume segment row for the active slot segment (or on-air in-between). */
export function FlowControlVirtualInBetweenPlayoutRow({
  virtual,
  isExpanded,
  onToggleExpand,
}: FlowControlVirtualInBetweenPlayoutRowProps) {
  const t = useTranslations();
  const label =
    virtual.segmentKind === 'flow_transition'
      ? t('flows.detail.control.transitionPlayout', { defaultValue: 'Transition playout' })
      : t('flows.detail.control.flowResumePlayout', { defaultValue: 'Flow resume playout' });

  return (
    <FlowControlPlayoutSegmentRow
      label={label}
      segmentAnchor="slot"
      segmentKind={virtual.segmentKind}
      segmentId={virtual.segmentId}
      slotId={virtual.slotId}
      isExpanded={isExpanded}
      isActive={virtual.isActive}
      onToggleExpand={onToggleExpand}
    />
  );
}
